import React, { useState, useEffect } from 'react';
// Force deployment update v2
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import Header from './components/Header/Header';
import ScrollProgress from './components/ScrollProgress/ScrollProgress';
import BackToTop from './components/BackToTop/BackToTop';
import Entry from './components/Entry/Entry';
import Home from './pages/Home/Home';
import Portfolio from './pages/Portfolio/Portfolio';
import BookingPage from './pages/BookingPage/BookingPage';
import MerchStore from './components/MerchStore/MerchStore';
import PresetStore from './components/PresetStore/PresetStore';
import Admin from './pages/Admin/Admin';
import Footer from './components/Footer/Footer';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <ErrorBoundary>
        <ThemeProvider>
          <LoadingScreen />
        </ThemeProvider>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <div className="App">
            <ScrollProgress />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Entry />} />
                <Route path="/home" element={<Home />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/store" element={<MerchStore />} />
                <Route path="/luts" element={<PresetStore />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<Entry />} />
              </Routes>
            </main>
            <Footer />
            <BackToTop />
          </div>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
